import { useEffect, useState } from "react";
import { whatsappUrl, trackWaClick } from "../lib/whatsapp";

const WhatsAppGlyph = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347Z"/>
    <path d="M20.52 3.449C18.24 1.17 15.24 0 12.04 0 5.46 0 .14 5.32.14 11.9c0 2.09.54 4.13 1.57 5.94L.03 24l6.36-1.67a11.89 11.89 0 0 0 5.64 1.44h.01c6.58 0 11.9-5.32 11.9-11.9 0-3.18-1.26-6.16-3.42-8.42ZM12.04 21.8h-.01a9.88 9.88 0 0 1-5.03-1.38l-.36-.21-3.78 1 1.01-3.68-.24-.38A9.85 9.85 0 0 1 2.13 11.9C2.14 6.45 6.6 2 12.05 2c2.66 0 5.15 1.04 7.03 2.92a9.83 9.83 0 0 1 2.91 7.01c-.01 5.46-4.46 9.87-9.95 9.87Z"/>
  </svg>
);

/**
 * Sticky Mobile-WhatsApp CTA. Erscheint nach dem ersten Scroll und ist nur auf
 * mobilen Viewports sichtbar. Dient als ständig greifbarer Conversion-Anker.
 */
const STICKY_REVEAL_SCROLL_PX = 320;

export default function MobileStickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const h = () => setVisible(window.scrollY > STICKY_REVEAL_SCROLL_PX);
    h();
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-[9998] px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 pointer-events-none transition-opacity duration-300 ${visible ? "opacity-100" : "opacity-0"}`}
      data-testid="mobile-sticky-cta-wrapper"
    >
      <a
        href={whatsappUrl()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWaClick("mobile_sticky")}
        className="pointer-events-auto flex items-center justify-center gap-2 rounded-full py-3.5 text-base font-semibold text-white shadow-[0_16px_40px_-8px_rgba(0,200,83,0.6)]"
        style={{ background: 'linear-gradient(135deg, #00C853 0%, #00E676 100%)' }}
        data-testid="mobile-sticky-cta"
      >
        <WhatsAppGlyph className="w-5 h-5" />
        Per WhatsApp starten
      </a>
    </div>
  );
}
